<template>
    <section>
        <div id="related-item" class="modal-mask" key="relatedItem">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <div class="modalBody">
                        <h2 class="listTitle ff-medium uppercase txtCenter">{{ $t("abonnement.title") }} : {{ $t("abonnement.diffusion") }}</h2>
                        <div class="">
                            <div class="form-group row">
                                <table class="table-borderless">
                                    <tbody>
                                        <tr v-for="(n, index) in diffusionUser">
                                            <td>{{ n.firstbame }}&nbsp;{{ n.lastname }}</td>
                                            <td>{{ n.email }}</td>
                                        </tr>
                                        <tr>
                                            <td id="newInputName"></td>
                                            <td id="newInputEmail"></td>
                                            <td id="newInputBrand"></td>
                                            <td id="save" @click="saveAdded();"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                        </div>
                        <br />
                        <!-- <button class="btn uppercase fright" @click="addToDiffusion()">{{ $t('abonnement.addUserToDiffusion') }}</button> -->
                        <br />
                        <br />
                        <br />
                        <div class="flexContainer fright">
                            <button class="btn uppercase" @click="close();">{{ $t("abonnement.previous") }}</button>
                            <!-- <button class="btn uppercase" style="margin-left: 10px;">{{ $t('abonnement.save') }}</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
//    import Vue from 'vue'
import "whatwg-fetch";
import httpService from "../../components/service";

export default {
    components: {},
    data() {
        return {
            diffusionUser: {}
        };
    },
    props: {},
    watch: {},
    methods: {
        saveAdded() {},
        addToDiffusion() {
            let elt1 = document.getElementById("newInputName");
            let elt2 = document.getElementById("newInputEmail");
            let elt3 = document.getElementById("newInputBrand");
            let input1 = document.createElement("input");
            let input2 = document.createElement("input");
            let input3 = document.createElement("input");
            elt1.appendChild(input1);
            elt2.appendChild(input2);
            elt3.appendChild(input3);
        },
        close() {
            this.$emit("hideDiffusionModal");
        }
    },
    computed: {},
    created() {
        httpService.get("/admin/subscription/detail").then(response => {
            this.diffusionUser = response.notification;
            console.log("=====", response.notification);
        });
    }
};
</script>

<style lang="scss" scoped>
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}
#zone {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#campaign {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 650px;
        min-height: 200px;
        background: #fff;
        border-radius: 4px;
        padding: 30px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Diffusion.vue?9e321c12